//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// img
import SearchSvg from "../../../assets/img/icon/icon_search.svg";

// componet
import BasicBtn from "../../../component/button/BasicBtn";

export default function NewPwdComplete() {
    //페이지 이동
    const navigate = useNavigate();
    const goHome = () => {
        navigate(`/`);
    };

    // 에러메세지
    const [error, setError] = useState(true);

    return (
        <Warp>
            <ContentWrap>
                <Title>SUCCESS!</Title>
                <Desc>비밀번호를 성공적으로 변경하였습니다.</Desc>
                <BtnWrap>
                    <BasicBtn onClick={goHome} text="홈으로" />
                </BtnWrap>
            </ContentWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vh - 100vw * (140 / 1920));

    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1300px) {
        height: calc(100vh - 100vw * (140 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: calc(100vh - 100vw * (51 / 428));
    }
`;

const ContentWrap = styled.div``;

const Title = styled.h2`
    font: calc(100vw * (50 / 1920)) "Pop-EL";
    text-align: center;

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(30)};

        margin-bottom: ${M(10)};
    }
`;

const BtnWrap = styled.div`
    width: calc(100vw * (200 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(180)};
    }
`;

const Desc = styled.p`
    font: calc(100vw * (14 / 1920)) "Noto-R";
    margin-bottom: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        margin-bottom: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-bottom: ${M(25)};
    }
`;
